import type { SelectedTalent, Talent } from "../shared/types";

export function getRosterList(uid: string, talent: Talent[]) {
    const myRosterTalent = talent
        .filter((t) => t.managerIds?.includes(uid))
        .reduce(
            (acc, t) => {
                acc[t.id] = {
                    price: undefined,
                };
                return acc;
            },
            {} as SelectedTalent,
        );

    const myRosterIds = talent.filter((t) => t.managerIds?.includes(uid)).map((t) => t.id);

    return {
        id: "my-roster",
        name: "My Roster",
        talentIds: myRosterIds,
        talent: myRosterTalent,
        active: true,
    };
}
